// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"1bc003f4","431":"c6e512cc"}[chunkId] + ".chunk.css";
};